import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames/bind';
import { convertStrDateToDMFormat } from '@beef/shop-common';

import { DELIVERY_TAKEAWAY_OFFICE } from 'store/ProductCatalog/constants';

import styles from './styles.pcss';

const cx = classNames.bind(styles);

export const Message = ({
  movement_id: movementId,
  movement_time: movementTime,
  movement_date: movementDate,
  ptype,
  minDate,
}) => {
  let productStatus =
    'Товар уже в офисе. Его можно забрать в течение 2 дней после звонка оператора.';
  if (movementId) {
    productStatus = `Товар будет в офисе c
    ${convertStrDateToDMFormat(
      movementDate,
    )} в ${movementTime}. Его можно забрать в течение 2 дней.`;
  } else if (ptype !== DELIVERY_TAKEAWAY_OFFICE) {
    productStatus = `Товар можно забрать ${convertStrDateToDMFormat(minDate)} и позднее.`;
  }
  if (!minDate) {
    productStatus = null;
  }
  return <div className={cx('ya-map__subtext')}>{productStatus}</div>;
};

Message.propTypes = {
  movement_id: PropTypes.number,
  movement_date: PropTypes.string,
  movement_time: PropTypes.string,
  ptype: PropTypes.string,
  minDate: PropTypes.string,
};
